<div class="px-4 py-2 ms-auto text-end" *ngIf="dataGrid && dataGrid.length > 0">
  <button mat-button [matMenuTriggerFor]="menu">
    <mat-icon>download</mat-icon>
    {{ 'map.map_table.export' | translate }}
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onExport('pdf')">
      {{ 'map.map_table.export_pdf' | translate }}
    </button>
    <button mat-menu-item (click)="onExport('csv')">
      {{ 'map.map_table.export_csv' | translate }}
    </button>
    <button mat-menu-item (click)="onExport('excel')">
      {{ 'map.map_table.export_excel' | translate }}
    </button>
  </mat-menu>
</div>

<div class="map-table-content">
  <mtx-grid
    #grid
    [data]="dataGrid"
    [columns]="columnsGrid"
    [showColumnMenuHeader]="false"
    [noResultText]="'common.no_result' | translate"
    [showFirstLastButtons]="false"
    [rowStriped]="true"
    [rowClassFormatter]="rowClassFormatter"
    [showPaginator]="true"
    [emptyValuePlaceholder]="'-'"
    [pageSize]="pageSize"
    [pageOnFront]="false"
    [pageIndex]="currentPageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [length]="totalCount"
    [sortOnFront]="false"
    [sortDisabled]="false"
    sortStart="asc"
    (sortChange)="onSortChange($event)"
    (page)="onPageChange($event)"
  >
  </mtx-grid>

  <ng-template #geometryColTemplate let-row>
    <button mat-icon-button color="primary" (click)="centerMapMarker(row)">
      <mat-icon>place</mat-icon>
    </button>
  </ng-template>

  <ng-template #idFeatureColTemplate let-row>
    <div style="text-align: center">{{ row.item_req?.split('keysZ')[1] }}</div>
  </ng-template>

  <ng-template #idColTemplate let-row>
    <div style="text-align: center">{{ row.id }}</div>
  </ng-template>

  <ng-template #infoColTemplate let-row>
    <button mat-icon-button color="primary" (click)="getFeatureInfo(row)" [disabled]="!row.item_req">
      <mat-icon>info</mat-icon>
    </button>
  </ng-template>
</div>
